module.exports = __webpack_public_path__ + "static/img/landing-bg.7b562a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing-bg.png
// module id = 111
// module chunks = 0